import './App.css';
import AppRoutes from './navigation/AppRoutes';
import { MainLayout } from './components';
import { Box } from '@mui/material';

function App() {
  return (
    <Box 
      sx={{ 
        display: "flex", 
        flexDirection: "column", 
        width: "100%", 
        textAlign: "center", 
        overflowX: "hidden", 
        overflowY: "auto"  
      }}
    >
      <MainLayout>
        <AppRoutes />
      </MainLayout>
    </Box>
  );
}

export default App;
